import React from "react"
import { Flex, Text } from "@chakra-ui/react"
import Icon from "components/elements/Icon"

type Props = {
  count: number;
  icon: string;
}

const CounterCell = ({ count, icon }: Props) => (
  <Flex align="center">
    <Icon
      icon={icon}
      size={4}
      mr={2}
      color={count > 0 ? "blue.500" : "gray.400"}
    />
    <Text fontSize="sm">{count}</Text>
  </Flex>
)

export default CounterCell
